<template>
  <div
    class="modal modal-sintomas fade"
    id="modal-rep-sintomas"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-sintomas__dialog"
    >
      <div class="modal-content modal-sintomas__content">
        <div class="modal-header modal-sintomas__header pb-1">
          <button
            type="button"
            class="btn-close modal-sintomas__btn-cerrar"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body modal-sintomas__body pt-0">
          <div class="container modal-sintomas__container">
            <div
              class="row modal-sintomas__row justify-content-center"
              v-if="preguntas"
            >
              <div
                class="
                  col-lg-12 col-md-12 col-11
                  text-start
                  mb-2
                  px-0
                  modal-sintomas__col modal-sintomas__col--borde-inf
                "
              >
                <h2 class="modal-sintomas__titulo mb-2" :style="{color: colorPrimario}">Reportar síntomas</h2>
              </div>

              <!-- Pregunta -->
              <div
                class="
                  col-lg-11 col-md-12 col-11
                  modal-sintomas__col-pregunta-1
                  text-start
                "
                v-for="(pregunta, index) in preguntas"
                :key="index"
                v-show="pagina_actual == index"
              >
                <div
                  class="row modal-sintomas__row justify-content-center mt-2"
                >
                  <div
                    class="
                      col-lg-2 col-md-3 col-4
                      modal-sintomas__col-botones
                      text-center
                    "
                  >
                    <button
                      class="modal-sintomas__paginador-boton"
                      v-if="index != 0"
                      @click="changePagina(index - 1, preguntas.length)"
                    >
                    <font-awesome-icon icon="fa-solid fa-angle-left" class="modal-sintomas__paginador-icono"></font-awesome-icon>
                    </button>
                    <span class="modal-sintomas__paginador-numero">{{
                      index + 1
                    }}</span>
                    de
                    <span class="modal-sintomas__paginador-numero">{{
                      preguntas.length
                    }}</span>
                    <button
                      class="modal-sintomas__paginador-boton"
                      v-if="index != preguntas.length - 1"
                      @click="changePagina(index + 1, preguntas.length)"
                      :disabled="
                        respuestas[pregunta.id_pregunta].respuesta == null
                      "
                    >
                    <font-awesome-icon icon="fa-solid fa-angle-right" class="modal-sintomas__paginador-icono"></font-awesome-icon>
                    </button>
                  </div>
                </div>
                <p class="modal-sintomas__titulo-b mt-3 mb-4">
                  {{ pregunta.texto_pregunta }}
                </p>
                <div class="row modal-sintomas__row">
                  <div
                    class="col-12 modal-sintomas__col"
                    v-for="alternativa in pregunta.alternativas"
                    :key="alternativa.id_alternativa"
                  >
                    <div
                      class="
                        form-check form-check-reverse
                        text-start
                        modal-sintomas__form-borde-sup
                      "
                    >
                      <label
                        class="form-check-label modal-sintomas__label"
                        for="flexRadioDefault1"
                      >
                        {{ alternativa.texto_alternativa }}
                      </label>
                      <input
                        class="form-check-input"
                        type="radio"
                        :name="`alternativas-pregunta-${index}`"
                        :value="alternativa.texto_alternativa"
                        v-model="respuestas[pregunta.id_pregunta].respuesta"
                        @change="onRespuestaChange"
                      />
                    </div>
                  </div>
                </div>
                <div class="row modal-sintomas__row">
                  <div
                    class="
                      col-lg-12 col-md-12 col-12
                      text-end
                      pt-3
                      px-0
                      modal-sintomas__col modal-sintomas__col--borde-sup
                    "
                  >
                    <button
                      class="modal-sintomas__btn-gris me-3"
                      data-bs-dismiss="modal"
                      @click="changePagina(0, preguntas.length)"
                    >
                      Cancelar
                    </button>
                    <button
                      class="modal-sintomas__btn-lila"
                      v-if="index != preguntas.length - 1"
                      @click="changePagina(index + 1, preguntas.length)"
                      :disabled="
                        respuestas[pregunta.id_pregunta].respuesta == null
                      "
                      :style="{ backgroundColor: colorPrimario }"
                    >
                      Siguiente
                    </button>

                    <button
                      class="modal-sintomas__btn-lila"
                      v-else
                      :disabled="
                        respuestas[pregunta.id_pregunta].respuesta == null
                      "
                      @click="handleSubmit"
                      :style="{ backgroundColor: colorPrimario }"
                    >
                      Siguiente
                    </button>
                    <!-- data-bs-toggle="modal"
                      data-bs-target="#modal-exito-sintomas" -->
                  </div>
                </div>
              </div>
              <!-- fin Pregunta -->
            </div>
          </div>
        </div>
        <div class="modal-footer modal-sintomas__footer pb-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
//import gql from "graphql-tag";
import { mapState ,mapActions } from "vuex";
// const ReportarSintomas = gql`
//   mutation ($respuestas: [RespuestasArr]) {
//     ReportarSintomas(
//       respuestas: $respuestas
//       id_empresa: "1"
//       id_usuario: "1"
//       temperatura: "0"
//       patente: ""
//       id_encuesta: "1"
//     ) {
//       id_respuesta
//     }
//   }
// `;

export default {
  name: "ModalReportarSintomas",
  data() {
    return {
      preguntas: null,
      pagina_actual: 0,
      respuestas: [],
    };
  },
  computed:{
    ...mapState("FolovidModule", ["EncuestaCovid"]),
  },
  created() {
    this.getCovidEncuesta();
  },
  methods: {
    ...mapActions("FolovidModule", ["getEncuestaCovid", "reportaSintoma"]),
    async getCovidEncuesta(){
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk
      }
      await this.getEncuestaCovid(data_).then(encuesta=>{
        this.preguntas = encuesta.preguntas;
        this.preguntas.map((pregunta) => {
          this.respuestas[pregunta.id_pregunta] = {
            id_pregunta: pregunta.id_pregunta,
            respuesta: null,
          };
        });
      })
    },
    changePagina(pagina, total) {
      if (pagina < 0) {
        pagina = 0;
      }
      if (pagina > total - 1) {
        pagina = total - 1;
      }

      this.pagina_actual = pagina;
    },
    onRespuestaChange() {
      this.$forceUpdate();
    },
    async  handleSubmit() {
      const finalArray = this.respuestas.filter((item) => {
        return item !== undefined;
      });

      // this.$apollo
      //   .mutate({
      //     mutation: ReportarSintomas,
      //     variables: {
      //       respuestas: finalArray,
      //     },
      //   })
      //   .then((data) => {
      //     const x = this;
      //     if (data.data.ReportarSintomas.id_respuesta) {
      //       document
      //         .getElementById("modal-rep-sintomas")
      //         .querySelector(".btn-close")
      //         .click();

      //       document.getElementById("btn-modal-exito-sintomas").click();
      //       Object.assign(x.$data, x.$options.data.apply(x));
      //       x.$apollo.queries.EncuestaCovid.refetch();
      //     }
      //   })
      //   .catch((error) => console.log(error));
        let data_ = {
          respuestas: finalArray,
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          temperatura: "0",
          patente: "",
          id_encuesta: "1",
        }
        await this.reportaSintoma(data_).then(res=>{
          if (res) {
              document
                .getElementById("modal-rep-sintomas")
                .querySelector(".btn-close")
                .click();

              document.getElementById("btn-modal-exito-sintomas").click();
              Object.assign(this.$data, this.$options.data.apply(this));
              //this.$apollo.queries.EncuestaCovid.refetch();
          }
        });
    },
  },
  // apollo: {
  //   EncuestaCovid: {
  //     query: gql`
  //       {
  //         EncuestaCovid(id_empresa: "1") {
  //           id_encuesta
  //           nombre_encuesta
  //           preguntas {
  //             id_pregunta
  //             texto_pregunta
  //             alternativas {
  //               id_alternativa
  //               texto_alternativa
  //             }
  //           }
  //         }
  //       }
  //     `,
  //     result(data) {
  //       this.preguntas = data.data.EncuestaCovid.preguntas;

  //       this.preguntas.map((pregunta) => {
  //         this.respuestas[pregunta.id_pregunta] = {
  //           id_pregunta: pregunta.id_pregunta,
  //           respuesta: null,
  //         };
  //       });
  //     },
  //   },
  // },
};
</script>